import script from "./m-edit-snippet-card.vue?vue&type=script&setup=true&lang=js"
export * from "./m-edit-snippet-card.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__